// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { skaleEuropaTestnet as _skaleEuropaTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the skaleEuropaTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1444673419
 * Chain Name: SKALE Europa Testnet
 * Default Block Explorer: https://juicy-low-small-testnet.explorer.testnet.skalenodes.com
 * Default RPC URL: https://testnet.skalenodes.com/v1/juicy-low-small-testnet
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { skaleEuropaTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: skaleEuropaTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const skaleEuropaTestnet = createCommon({
	..._skaleEuropaTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
